export default __webpack_public_path__ + "static/media/photo10.436caea2.jpg";